<app-vca-content-project *ngIf="pageId == 'vca-content-project'" [userInfos]="userInfos"></app-vca-content-project>
<app-vca-create-project *ngIf="pageId == 'vca-create-project'" [userInfos]="userInfos"></app-vca-create-project>
<app-vca-upload-content *ngIf="pageId == 'vca-upload-content'" [userInfos]="userInfos"></app-vca-upload-content>

<app-vca-student-dashboard *ngIf="pageId == 'vca-student-dashboard'" [userInfos]="userInfos"></app-vca-student-dashboard>
<app-vca-student-manager *ngIf="pageId == 'vca-student-manager'" [userInfos]="userInfos"></app-vca-student-manager>
<app-vca-ressource-manager *ngIf="pageId == 'vca-manage-ressource'" [userInfos]="userInfos"></app-vca-ressource-manager>
<app-vca-advertisment *ngIf="pageId == 'vca-advertisment'" [userInfos]="userInfos"></app-vca-advertisment>
<app-vca-promotion *ngIf="pageId == 'vca-promotion'" [userInfos]="userInfos"></app-vca-promotion>


